import { VOutlineIcon } from '@carboncopyco/icons';
import { ShareSecurityLevel } from '@carboncopyco/types';
import { ConfirmAlert } from '@carboncopyco/ui';

export function shouldShowSecurityLevelWarning(
  prevSecurityLevel: ShareSecurityLevel,
  selectedSecurityLevel: ShareSecurityLevel
) {
  if (
    selectedSecurityLevel === prevSecurityLevel ||
    selectedSecurityLevel === ShareSecurityLevel.anyone
  ) {
    return false;
  }
  return true;
}

type UpdateSecurityLevelWarningModalProps = {
  show: boolean;
  onConfirm: () => void;
  onClose: () => void;
  isLoading?: boolean;
};

export const UpdateSecurityLevelWarningModal = ({
  show,
  onConfirm,
  onClose,
  isLoading,
}: UpdateSecurityLevelWarningModalProps) => {
  return (
    <ConfirmAlert
      title="Notice"
      show={show}
      onConfirm={onConfirm}
      onClose={onClose}
      description="Some visitors may lose access to this link because of your updated security settings"
      yesIcon={<VOutlineIcon />}
      yesLabel="Got it"
      noLabel="Cancel"
      loading={isLoading}
    />
  );
};
